<div *ngIf="gridType == 'landscape'">
  <div>
    <div *ngIf="data?.thumbnails?.length > 0">
      <!-- <h1>sddsfsdfsdfdsf</h1> -->
      <div class="delete-content" [id]="type + data.sorting_date">
        <div
          class="ratio-slider ratio-16-9 view-content"
          [routerLink]="data | redirectUrl"
          [queryParams]="data | queryParamUrl"
          (mouseenter)="
            !watchingStatus && (data?.view_days === 0 || !data?.view_days)
              ? gridConfig.landscape.hover &&
                service.playOn($event, data, type, data.sorting_date)
              : playOff()
          "
        >
          <img
            src="{{ data?.thumbnails | thumbnails: 'landscape' }}"
            [src-fallback]="app_constant.landscapeDefault"
          />
          <!-- <div class="overlay">
            <a href="javascript:void(0)" class="btn-play">
              <span class="icon-play-button"></span>
            </a>
          </div> -->
          <div
            class="live-box"
            *ngIf="type === 'live' && data?.channel_content?.start_time"
          >
            <countdown
              *ngIf="!data?.showTimer"
              #cd
              [config]="data | timerValue"
              (event)="handleEvent($event, data)"
            ></countdown>
            <span class="live-tag" *ngIf="data?.showTimer"> Live </span>
          </div>
          <div class="watch-icons">
            <span *ngIf="data.source == 'daily_motion'">
              <img src="assets/images/dailymotion.png" class="video_icons" />
              Daily Motion</span
            >
            <span *ngIf="data.source == 'vimeo'">
              <img src="assets/images/vimeo.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'youtube'">
              <img src="assets/images/youtube.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
          </div>

          <!-- <div
            *ngIf="
              (data?.view_days | viewdays:'').status &&
              status !== 'Continue_Watching' &&
              data?.type !== 'series'
            "
            class="lock-video-box"
            matTooltip="This content will active after {{
              data?.view_days | viewdays: ''
            }} days"
            matTooltipPosition="above"
          >
            <span class="mdi mdi-lock"></span>
          </div> -->
          <div
            class="progress mb-2"
            *ngIf="
              watchingStatus &&
              (data.type == 'video' ||
                data.type == 'live' ||
                data.type == 'series') &&
              data?.view_duration > 0
            "
          >
            <div
              class="progress-bar"
              role="progressbar"
              [ngStyle]="{
                width: (data?.view_duration / data?.total_duration) * 100 + '%'
              }"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <a
          *ngIf="watchingStatus"
          class="delete-icon cursor-pointer"
          (click)="
            continueWatchingComponent.deleteContinueWatching(data?.public_id)
          "
        >
          <span class="icon-close"></span>
        </a>
        <div class="series-content">
          <div class="slider-titles" *ngIf="gridConfig.landscape.title">
            <p class="sub-title">
              <span *ngIf="data.duration">
                {{ data.duration | second_time }}
              </span>
              <span *ngIf="data.total_episode && data.duration" class="dots">
              </span>
              <span *ngIf="data.total_episode">
                {{ data.total_episode }} contents</span
              >
            </p>
            <h5 class="title">{{ data.name }}</h5>
          </div>
        </div>
      </div>
    </div>
    <div
      class="delete-content"
      *ngIf="data?.thumbnails?.length == 0"
      [id]="type + data.sorting_date"
    >
      <div
        class="ratio-slider ratio-16-9"
        [routerLink]="data | redirectUrl"
        [queryParams]="data | queryParamUrl"
        [queryParams]="data.series_id ? { episode: data.public_id } : ''"
        (mouseenter)="
          !watchingStatus && (data?.view_days === 0 || !data?.view_days)
            ? gridConfig.landscape.hover &&
              service.playOn($event, data, type, data.sorting_date)
            : playOff()
        "
      >
        <img [src]="app_constant.landscapeDefault" />
        <div
          class="live-box"
          *ngIf="type === 'live' && data?.channel_content?.start_time"
        >
          <countdown
            *ngIf="!data.showTimer"
            #cd
            [config]="data | timerValue"
            (event)="handleEvent($event, data)"
          ></countdown>

          <span class="live-tag" *ngIf="data?.showTimer"> Live </span>
        </div>
        <div
          class="progress mb-2"
          *ngIf="
            watchingStatus &&
            (data.type == 'video' || data.type == 'live') &&
            data?.view_duration > 0
          "
        >
          <div
            class="progress-bar"
            role="progressbar"
            [ngStyle]="{
              width: (data?.view_duration / data?.total_duration) * 100 + '%'
            }"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <a
        *ngIf="watchingStatus"
        class="delete-icon cursor-pointer"
        (click)="
          continueWatchingComponent.deleteContinueWatching(data?.public_id)
        "
      >
        <span class="icon-close"></span>
      </a>
      <div class="series-content">
        <div class="slider-titles" *ngIf="gridConfig.landscape.title">
          <p class="sub-title">
            <span *ngIf="data.duration">
              {{ data.duration | second_time }}
            </span>
            <span *ngIf="data.total_episode && data.duration" class="dots">
            </span>
            <span *ngIf="data.total_episode">
              {{ data.total_episode }} contents</span
            >
          </p>
          <h5 class="title">{{ data.name }}</h5>
        </div>
      </div>
    </div>
    <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
      "HOME.PREMIUM" | translate
    }}</span> -->
  </div>
</div>

<div *ngIf="gridType == 'portrait'">
  <div [routerLink]="data | redirectUrl" [queryParams]="data | queryParamUrl">
    <div
      *ngIf="
        data?.thumbnails?.length > 0 ||
        data?.content_info?.thumbnails?.length > 0
      "
    >
      <div>
        <div
          class="ratio-slider ratio-2-3 view-content"
          [id]="data.public_id_index"
          (mouseenter)="
            gridConfig.portrait.hover &&
              service.playOn($event, data, type, data.public_id)
          "
        >
          <img
            src="{{ data?.thumbnails | thumbnails: 'portrait' }}"
            [src-fallback]="app_constant.portraitDefault"
          />
          <img
            *ngIf="data?.content_info?.thumbnails"
            src="{{ data?.content_info?.thumbnails | thumbnails: 'portrait' }}"
            [src-fallback]="app_constant.portraitDefault"
          />
          <!-- <div class="overlay">
            <a href="javascript:void(0)" class="btn-play">
              <span class="icon-play-button"></span>
            </a>
          </div> -->
          <div class="watch-icons">
            <span *ngIf="data.source == 'daily_motion'">
              <img src="assets/images/dailymotion.png" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'vimeo'">
              <img src="assets/images/vimeo.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'youtube'">
              <img src="assets/images/youtube.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
          </div>
          <!-- <div
            *ngIf="data?.view_days | viewdays: ''"
            class="lock-video-box"
            matTooltip="This content will active after {{
              data?.view_days | viewdays: ''
            }} days"
            matTooltipPosition="above"
          >
            <span class="mdi mdi-lock"></span>
          </div> -->
        </div>
        <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
          "HOME.PREMIUM" | translate
        }}</span> -->
        <div class="slider-titles" *ngIf="gridConfig.portrait.title">
          <p class="sub-title">
            <span *ngIf="data.duration">
              {{ data.duration | second_time }}
            </span>
            <span *ngIf="data.total_episode && data.duration" class="dots">
            </span>
            <span *ngIf="data.total_episode">
              {{ data.total_episode }} contents</span
            >
          </p>
          <h5 class="title">{{ data.name }}</h5>
        </div>
      </div>
    </div>
    <div *ngIf="data?.thumbnails?.length == 0">
      <div class="ratio-slider ratio-2-3">
        <img [src]="app_constant.portraitDefault" />
      </div>
      <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
        "HOME.PREMIUM" | translate
      }}</span> -->
      <div class="slider-titles" *ngIf="gridConfig.portrait.title">
        <p class="sub-title">
          <span *ngIf="data.duration">
            {{ data.duration | second_time }}
          </span>
          <span *ngIf="data.total_episode && data.duration" class="dots">
          </span>
          <span *ngIf="data.total_episode">
            {{ data.total_episode }} contents</span
          >
        </p>
        <h5 class="title">{{ data.name }}</h5>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="
    gridType == 'square' && (type === 'partner_list' || type === 'partner_home')
  "
>
  <div [routerLink]="data | redirectUrl" [queryParams]="data | queryParamUrl">
    <div>
      <div class="patner-slid">
        <div class="ratio-slider ratio-1-1">
          <img
            src="{{ data?.image }}"
            [src-fallback]="app_constant.userNoImage"
          />
          <div class="watch-icons">
            <span *ngIf="data.source == 'daily_motion'">
              <img src="assets/images/dailymotion.png" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'vimeo'">
              <img src="assets/images/vimeo.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'youtube'">
              <img src="assets/images/youtube.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
          </div>
        </div>
        <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
          "HOME.PREMIUM" | translate
        }}</span> -->
        <div class="slider-titles">
          <p class="sub-title">
            {{ "GRID.TOTAL_CONTENT" | translate }}: {{ data.total_content }}
          </p>
          <p class="sub-title" *ngIf="type === 'partner_list'">
            Registered At {{ data.created_at | date: app_constant.dobFormat }}
          </p>
          <p class="sub-title">
            <span *ngIf="data.duration">
              {{ data.duration | second_time }}
            </span>
            <span *ngIf="data.total_episode && data.duration" class="dots">
            </span>
            <span *ngIf="data.total_episode">
              {{ data.total_episode }} contents</span
            >
          </p>
          <h5 class="title text-center">{{ data.name }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="
    gridType == 'square' && (type !== 'partner_list' || type !== 'partner_home')
  "
>
  <div [routerLink]="data | redirectUrl" [queryParams]="data | queryParamUrl">
    <div *ngIf="data?.thumbnails?.length > 0">
      <div>
        <div class="ratio-slider ratio-1-1">
          <img
            src="{{ data?.thumbnails | thumbnails: 'square' }}"
            [src-fallback]="app_constant.landscapeDefault"
          />

          <div class="watch-icons">
            <span *ngIf="data.source == 'daily_motion'">
              <img src="assets/images/dailymotion.png" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'vimeo'">
              <img src="assets/images/vimeo.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'youtube'">
              <img src="assets/images/youtube.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
          </div>
        </div>

        <div class="slider-titles">
          <p class="sub-title">
            <span *ngIf="data.duration">
              {{ data.duration | second_time }}
            </span>
            <span *ngIf="data.total_song">
              {{
                data.total_song == "1"
                  ? data.total_song + " Track"
                  : data.total_song + " Tracks"
              }}
            </span>
            <span *ngIf="data.total_episode && data.duration" class="dots">
            </span>
            <span *ngIf="data.total_episode">
              {{ data.total_episode }} contents</span
            >
          </p>
          <h5 class="title">{{ data.name }}</h5>
        </div>
      </div>
    </div>
    <div *ngIf="data?.thumbnails?.length == 0">
      <div class="ratio-slider ratio-1-1">
        <img [src]="app_constant.squareDefault" />
      </div>
      <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
        "HOME.PREMIUM" | translate
      }}</span> -->
      <div class="slider-titles">
        <p class="sub-title">
          <span *ngIf="data.duration">
            {{ data.duration | second_time }}
          </span>
          <span *ngIf="data.total_episode && data.duration" class="dots">
          </span>
          <span *ngIf="data.total_episode">
            {{ data.total_episode }} contents</span
          >
        </p>
        <h5 class="title">{{ data.name }}</h5>
      </div>
    </div>
  </div>
</div>

<div *ngIf="gridType == 'circle'">
  <div [routerLink]="data | redirectUrl" [queryParams]="data | queryParamUrl">
    <div *ngIf="data.thumbnails.length > 0">
      <div>
        <div class="ratio-slider ratio-1-1">
          <img
            src="{{ data?.thumbnails | thumbnails: 'landscape' }}"
            [src-fallback]="app_constant.landscapeDefault"
          />
          <!-- <div class="overlay">
            <a href="javascript:void(0)" class="btn-play">
              <span class="icon-play-button"></span>
            </a>
          </div> -->
          <div class="watch-icons">
            <span *ngIf="data.source == 'daily_motion'">
              <img src="assets/images/dailymotion.png" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'vimeo'">
              <img src="assets/images/vimeo.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
            <span *ngIf="data.source == 'youtube'">
              <img src="assets/images/youtube.svg" class="video_icons" />
              {{ data.source | titlecase }}</span
            >
          </div>
        </div>
        <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
          "HOME.PREMIUM" | translate
        }}</span> -->
        <div class="slider-titles" *ngIf="gridConfig.portrait.square">
          <p class="sub-title">
            <span *ngIf="data.duration">
              {{ data.duration | second_time }}
            </span>
            <span *ngIf="data.total_episode && data.duration" class="dots">
            </span>
            <span *ngIf="data.total_episode">
              {{ data.total_episode }} contents</span
            >
          </p>
          <h5 class="title">{{ data.name }}</h5>
        </div>
      </div>
    </div>
    <div *ngIf="data.thumbnails.length == 0">
      <div class="ratio-slider ratio-1-1">
        <img [src]="app_constant.landscapeDefault" />
      </div>
      <!-- <span class="pre_batch" *ngIf="data?.is_access == 'paid'">{{
        "HOME.PREMIUM" | translate
      }}</span> -->
      <div class="slider-titles" *ngIf="gridConfig.portrait.square">
        <p class="sub-title">
          <span *ngIf="data.duration">
            {{ data.duration | second_time }}
          </span>
          <span *ngIf="data.total_episode && data.duration" class="dots">
          </span>
          <span *ngIf="data.total_episode">
            {{ data.total_episode }} contents</span
          >
        </p>
        <h5 class="title">{{ data.name }}</h5>
      </div>
    </div>
  </div>
</div>
